import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "nonzero"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#20BC48",
    d: "M22.048 14.692 22.392 18l-3.04 1.356L18 22.392l-3.308-.344L12 24l-2.692-1.952L6 22.392l-1.356-3.04L1.608 18l.344-3.308L0 12l1.952-2.692L1.608 6l3.04-1.356L6 1.608l3.308.344L12 0l2.692 1.952L18 1.608l1.356 3.04L22.392 6l-.344 3.308L24 12z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFF",
    d: "m17.684 8.685-1.137-1.106-6.819 6.63-2.275-2.207-1.137 1.102 3.412 3.317z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }